var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.593262C6.71268 0.593262 0 7.32391 0 15.6334C0 23.9428 6.71268 30.6735 15 30.6735C23.2873 30.6735 30 23.9428 30 15.6334C30 7.32391 23.2873 0.593262 15 0.593262ZM15 28.7623C7.79003 28.7623 1.98894 22.8626 1.98894 15.7165C1.98894 8.81961 7.29281 3.25229 14.0055 2.67062V16.7136H24.4475V14.8024H15.9116V2.58753C22.6243 3.0861 28.011 8.73652 28.011 15.6334C28.011 22.8626 22.2099 28.7623 15 28.7623Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Clock.72404a69f2ede6caae96fc1a5649fbe9.svg";